import { Badge, Button, ClickAwayListener, Grid, Popover, Typography } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import Tooltip from '@mui/material/Tooltip';
import useProfileMenu from '~/hooks/useProfileMenu';
import UserProfileIcon from '~/assets/user_profile.png';
import LogoutIcon from '@mui/icons-material/Logout';
import { useAppContext } from '~/AppProviders';

export default function ProfileMenu() {
  const { open, anchorElement, handleClick, handleClose, handleLogOutClick } = useProfileMenu();
  const { userName = 'User', accountName = 'Tester' } = useAppContext();
  return (
    <>
      <Box
        className="profile-container"
        sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
        <Tooltip title="Profile Menu">
          <IconButton
            onClick={handleClick}
            size="small"
            sx={{ ml: 2, p: 0 }}
            aria-controls={open ? 'account-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}>
            <Badge
              overlap="circular"
              anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
              className="profile-badge">
              <Avatar
                src={UserProfileIcon}
                className="profile-avatar"></Avatar>
            </Badge>
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorElement}
        id="profile-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}>
        <Popover
          open={open}
          anchorEl={anchorElement}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          slotProps={{
            paper: {
              sx: {
                mt: 1,
                p: 2,
                width: 280,
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
              },
            },
          }}>
          <ClickAwayListener onClickAway={handleClose}>
            <Grid
              container
              spacing={2}>
              <Grid size={12}>
                <Typography
                  fontWeight="bold"
                  variant="body1">
                  Account({accountName})
                </Typography>
              </Grid>
              <Grid
                size={12}
                sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Avatar
                  sx={{ width: 40, height: 40, bgcolor: 'primary.main' }}
                  variant="circular">
                  {userName?.charAt(0)?.toUpperCase()}
                </Avatar>
                <Typography variant="body1">Hi, {userName}!</Typography>
              </Grid>
              <Grid size={12}>
                <Button
                  startIcon={<LogoutIcon />}
                  variant="outlined"
                  fullWidth
                  onClick={() => {
                    handleLogOutClick();
                    handleClose();
                  }}>
                  Logout
                </Button>
              </Grid>
            </Grid>
          </ClickAwayListener>
        </Popover>
      </Menu>
    </>
  );
}
